var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99984,
    cy: 9.99935,
    r: 8.33333,
    fill: "#17C5D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0418 6.66667C11.0418 7.24196 10.5755 7.70833 10.0002 7.70833C9.42487 7.70833 8.9585 7.24196 8.9585 6.66667C8.9585 6.09137 9.42487 5.625 10.0002 5.625C10.5755 5.625 11.0418 6.09137 11.0418 6.66667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.58398V13.334",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.2be3b191885276016e4dfec70372abf8.svg";
export { ForwardRef as ReactComponent };